import { Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../../../core/helper/validtors-helper';

export const Validation = {
  user: {
    FIRSTNAME: {
      pattren: [
        Validators.required,
        Validators.pattern('^[a-zA-Z ]+$'),
        noWhitespaceValidator,
      ],
      isRequired: true,
    },
    LASTNAME: {
      pattren: [
        Validators.required,
        Validators.pattern('^[a-zA-Z ]+$'),
        noWhitespaceValidator,
      ],
      isRequired: true,
    },
    USERNAME: {
      pattren: [
        noWhitespaceValidator,
        Validators.required,
        Validators.email,
        noWhitespaceValidator,
      ],
      isRequired: true,
    },
    PHONE: {
      pattren: [
        Validators.required,
        Validators.pattern(/^\+?[0-9\s\-()]{7,20}$/),
        noWhitespaceValidator,
      ],
      isRequired: true,
    },
    EMAIL: {
      pattren: [
         Validators.required,
        noWhitespaceValidator,       
        // Validators.email,
        noWhitespaceValidator,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ],
      isRequired: true,
    },
    ROLE: {
      pattren: [noWhitespaceValidator, Validators.required],
      noWhitespaceValidator,
      isRequired: true,
    },
    ASSIGNEDPRACTICE: {
      pattren: [noWhitespaceValidator, Validators.required],
      noWhitespaceValidator,
      isRequired: true,
    },
    LANGUAGE: {
      pattren: [noWhitespaceValidator, Validators.required],
      noWhitespaceValidator,
      isRequired: true,
    },
    PASSWORD: {
      pattren: [
        Validators.required,
        Validators.pattern(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=[\]\{\}\|\\:;"'<>,\./`])[A-Za-z\d@$!%*?&#^()_+\-=[\]\{\}\|\\:;"'<>,\./`]{8,15}$/,
        ),
        Validators.maxLength(15),
        noWhitespaceValidator,
      ],
      isRequired: true,
      validationMessage: 'Password must include at least one uppercase letter, one lowercase letter, one number, and one special character.'
    },
    TIMEZONE: {
      pattren: [noWhitespaceValidator, Validators.required],
      noWhitespaceValidator,
      isRequired: true,
    },
    GROUP: {
      pattren: [noWhitespaceValidator, Validators.required],
      noWhitespaceValidator,
      isRequired: true,
    },

    USERTYPE: {
      pattren: [noWhitespaceValidator, Validators.required],
      noWhitespaceValidator,
      isRequired: true,
    },
    IMAGE: {
      pattren: [noWhitespaceValidator, Validators.required],
      noWhitespaceValidator,
      isRequired: false,
    },
  },
};
